<div class="container">
  <ion-img [src]="icon"></ion-img>
  <ion-label>{{ type }}</ion-label>
</div>
